//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 
import UMUM         from "../../library/umum"        ;
import WILAYAH      from "../../library/getWilayah"  ;
import CHART        from '../../library/chart'       ;
import FETCHING     from '../../library/fetching'    ;


export default {
  data() {
    return {
      form : {
        id : '',
        des_kel : '',
        tahun : '2020',
      },
     
      list_data : [],
      cek_load_data : true, 

      listKegiatan: [],

      page_limit: 1000,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,

      UMUM: UMUM
    };
  },
  methods: {
    getView : async function(){
      var body = this.form
      this.list_data = await FETCHING.postDataPublish(this.$store.state.url.URL_CNT_KECAMATAN_KECAMATAN, 'LayananPendidikan', body);
    //   console.log(this.list_data)
    },
    chartnya : async function(){
      var body = this.form
      var dataArray = await CHART.postData(this.$store.state.url.URL_CNT_KECAMATAN_DASHBOARD, 'LayananPendidikan', body);
      console.log(dataArray)
      CHART.BarChart('barchartnya', 'Layanan Pendidikan', '', dataArray.uraian , dataArray.jumlah, '')
    },
    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
            this.chartnya();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        }
        
    // ====================================== PAGINATE ====================================
  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id;
    WILAYAH.getListDesKelFull();
    this.cari_data();
    // this.chartnya();
  }
};
